import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    event.stopPropagation()
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  clickBackdrop(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }
}
